import { AxiosService } from '../../services/axiosService';

export const updateUserApi = (modifiedUserId, data = {}) => {
  return AxiosService.put('/internalUser/user', {
    modifiedUserId,
    ...data
  });
};
